import React, { createContext, createElement, FC, ReactNode, useCallback, useContext } from 'react';

import { LangContext } from '../LangProvider';

import { IMainContext, IMainProvider } from './interfaces';

// components
import { TYPE_COMPONENTS } from '../../components';

// main context
const MainContext = createContext({} as IMainContext);

// main provider
const MainProvider: FC<IMainProvider> = ({ children }) => {
  const { lang }: any = useContext(LangContext);

  // find element
  const findElement = useCallback((type): any =>
    TYPE_COMPONENTS.find((item: any) => type === item.type), []);

  // create element
  const createElementPage = useCallback((element, index, page) => {
    const { id, type, value } = element;
    const component = findElement(type);

    if (!component || !value || typeof value !== 'object') return null;

    return createElement(component.componentElement, {
      componentId: id,
      key: id || index,
      lang: lang?.lang,
      pageApiUrl: page?.meta?.detail_url,
      value,
    });
  }, [ lang, findElement ]);

  // load page
  const onLoadPage = useCallback((page: any) => {
    if (!Array.isArray(page?.corpo)) return null;

    return page.corpo.map((item: ReactNode, index: number) =>
      createElementPage(item, index, page));
  }, [ createElementPage ]);
  
  // render
  return (
    <MainContext.Provider value={{
      onLoadPage
    }}>{children}
    </MainContext.Provider>
  );
};

export { MainContext, MainProvider };
export default MainProvider;
